<template>
  <div class="tw-w-full tw-px-0 md:tw-px-8 tw-py-5">
    <div v-if="scanObject(coverType, 'coverTypeId') === 120">
      <v-stepper alt-labels>
        <v-stepper-header class="tw-flex tw-flex-row">
          <v-stepper-step
              step="1"
              :complete="progress > 0"
          >
            Insured Details
          </v-stepper-step>
          <v-divider :color="progress > 0 ? 'secondary' : ''"></v-divider>
          <v-stepper-step
              step="2"
              :complete="progress > 20"
          >
            Vehicle Details
          </v-stepper-step>
          <v-divider :color="progress > 20 ? 'secondary' : ''"></v-divider>
          <v-stepper-step
              step="3"
              :complete="progress > 40"
          >
            Change Cover &amp; Payment Plan
          </v-stepper-step>
          <v-divider :color="progress > 40 ? 'secondary' : ''"></v-divider>
          <v-stepper-step
              :complete="progress > 60"
              step="4">
            Select Valuer &amp; Branch
          </v-stepper-step>
          <v-divider :color="progress > 60 ? 'secondary' : ''"></v-divider>
          <v-stepper-step
              :complete="progress === 100"
              step="5">
            Make Payment
          </v-stepper-step>
        </v-stepper-header>
      </v-stepper>
    </div>
    <div v-else-if="scanObject(coverType, 'coverTypeId') === 121" >
      <v-stepper alt-labels>
        <v-stepper-header>
          <v-stepper-step
              step="1"
              :complete="progress > 0"
          >
            Insured Details
          </v-stepper-step>
          <v-divider :color="progress > 0 ? 'secondary' : ''"></v-divider>
          <v-stepper-step
              step="2"
              :complete="progress > 30"
          >
            Vehicle Details
          </v-stepper-step>
          <v-divider :color="progress > 30 ? 'secondary' : ''"></v-divider>
          <v-stepper-step
              step="3"
              :complete="progress > 67"
          >
            Cover Summary
          </v-stepper-step>
          <v-divider :color="progress > 67 ? 'secondary' : ''"></v-divider>
          <v-stepper-step
              :complete="progress === 100"
              step="4">
            Make Payment
          </v-stepper-step>
        </v-stepper-header>
      </v-stepper>
    </div>
  </div>
</template>
<script>

import helperMixins from '@/mixins/helperMixins';

export default {
  name: 'TopStepper',
  props: {
    current: {
      type: String,
      default: '',
    },
    coverType: Object,
  },
  mixins: [helperMixins],
  computed: {
    progress() {
      if (this.coverType.coverTypeId === 120) {
        return this.compProgress;
      }
      if (this.coverType.coverTypeId === 121) {
        return this.tpoProgress;
      }
      return 100;
    },
    compProgress() {
      if (this.current === 'PersonalDetails') {
        return 0;
      }
      if (this.current === 'VehicleDetails') {
        return 22;
      }
      if (this.current === 'CoverChange') {
        return 44;
      }
      if (this.current === 'BranchSelections') {
        return 66;
      }
      return 100;
    },
    tpoProgress() {
      if (this.current === 'PersonalDetails') {
        return 0;
      }
      if (this.current === 'VehicleDetails') {
        return 33.33;
      }
      if (this.current === 'CoverSummary') {
        return 66.66;
      }
      if (this.current === 'BranchSelections') {
        return 80;
      }
      return 100;
    },
  },
};
</script>
